const links = {

    // mmshwal:"https://mmshawl.nyggs.com:81/",
    // mmshwalModuleSelection:"https://mmshawl.nyggs.com:81/api/",
    // sso:"https://sso.nyggs.com:82/",
    // staging:"http://stagingservicesv1.nyggs.com:82/api/",
    // prod:"https://servicesv1.nyggs.com:82/api/",
    // nkc:"https://nkcsso.nyggs.com:75/api/",
    // nkc:"https://demosso.nyggs.com:75/api/",
    // nkc:"http://192.168.30.30:93/api",
    // nkcAuthenticate:"https://nkcsso.nyggs.com:75/"
    // nkcAuthenticate:"https://demosso.nyggs.com:75/"


    // PROD
    nkc: "https://demosso.nyggs.com/backend/hrms/api/",
        nkcModuleSelection: "https://demosso.nyggs.com/backend/sso/api/",
    nkcAuthenticate: "https://demosso.nyggs.com/backend/sso/"
}
export default links